import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable, of } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class ParametroService implements RequestCRUD<any, ResponseServiceModel> {
	private API_URL;
	private handleError: HandleError;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
		this.handleError = httpErrorHandler.createHandleError('Parametro');
	}

	get(entry: any): Observable<ResponseServiceModel> {
		// tslint:disable-next-line:max-line-length
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/ParametroAdministrador/Paginado?PageNumber=${entry.numeroPagina}&PageSize=12`, entry).pipe(
			retry(2)
		);
	}
	update(entry: any): Observable<ResponseServiceModel> {
		return this.http.put<ResponseServiceModel>(`${this.API_URL}/ParametroAdministrador`, entry).pipe(
			retry(2)
		);
	}
	create(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/ParametroAdministrador/Crear`, entry).pipe(
			retry(2)
		);
	}
	delete(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/ParametroAdministrador/Eliminar`, entry).pipe(
			retry(2)
		);
	}

}
